import axios from "../../../utils/request"
function GET_LIST(params) {
    return axios.get("/customer/AGoogleSearchConsole/index", {
        params: params
    })
}
// 关联Google Serach Console
function ADD_GOOGLE_ACCOUNT(params) {
    return axios.get("/customer/AGoogleSearchConsole/addGoogleAccount", {
      params: params
    })
}
// 删除
function DELE(params) {
    return axios.get("/customer/AGoogleSearchConsole/delete", {
      params: { id: params }
    })
} 
export default {
  GET_LIST,
  ADD_GOOGLE_ACCOUNT,
  DELE
}
